<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-8" align="left">
               <h1>Withdraw List</h1>
            </div>
            <div class="col-xs-4">
               <router-link :to="{path: 'addnewwithdrawal'}" class="btn btn-sm btn-add">
                  <i class="fa fa-plus-square"></i> Add New Withdraw
               </router-link>
               <a class="btn btn-sm btn-add" @click="RefreshNow">
                  <i class="fa fa-refresh"></i>Refresh
               </a>
            </div>
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="dopagination(0)">
         <div class="row">
            <div class="col-xs-6 col-sm-4 form-group">
               <select title="" name="account_id" v-model="account_id" v-select="account_id" id="account_id" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value=""> -- All Accounts -- </option>
                  <option :value="data.id" v-for="(data, index) in account_list" :key="data.id">{{data.bank_name}} [A/C: {{data.acc_name}} - {{data.acc_number}}]</option>
               </select>
            </div>

            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="status" v-model="status" v-select="status" id="status" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="">All</option>
                  <option value="0">Pending</option>
                  <option value="1">Admin Settled</option>
                  <option value="2">Admin Declined</option>
                  <option value="3">Cancelled</option>
               </select>
            </div>
            <div class="col-xs-3 col-sm-1 form-group">
               <select title="" name="limit" id="limit" v-model="display_limit" v-select="display_limit" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
               </select>
            </div>
            <div class="col-xs-2 form-group">
               <button type="submit" class="btn btn-sm btn-submit">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>
         <div class="row">
            <div class="col-sm-12">
               <div class="alert alert-info" v-if="alert_message">
                  {{alert_message}}
               </div>
            </div>
            <div class="col-md-12">
               <div class="box">
                  <div class="box-header">
                     <h3 class="box-title">
                        Total : {{totalData}} 
                        <span v-if="dispplayFrom">
                           Showing {{dispplayFrom}} to {{dispplayTo}}
                        </span>
                        <span class="pull-right noOfData">
                           {{totalData}}
                        </span>
                     </h3>
                  </div>
                  <div class="box-body">
                     <div class="table-responsive">
                        <table class="table table-0024 table-bordered table-striped">
                           <thead>
                              <tr>
                                 <th class="tdCenter tdSN">SN</th>
                                 <th>Date</th>
                                 <th>Gateway Name</th>
                                 <th>Account Name </th>
                                 <th>Account Number</th>
                                 <th>Last Balance</th>
                                 <th>Requested Amount</th>
                                 <th width="120">Description</th>
                                 <th width="120">Admin Remarks</th>
                                 <th class="tdCenter">Status</th>
                                 <th class="tdCenter">Action</th>
                              </tr>
                           </thead>
                           <tbody v-if="withdrawArr.length > 0">
                              <tr v-for="(data, index) in withdrawArr" :key="data.id">
                                 <td class="tdCenter tdSN">
                                    {{parseInt(index)+1}}
                                 </td>
                                 <td>{{data.created_at}}</td>
                                 <td>{{data.bank_name}}</td>
                                 <td>{{data.acc_name}}</td>
                                 <td>{{data.acc_number}}</td>
                                 <td>{{data.last_balance}}</td>
                                 <td>{{data.requested_amount}}</td>
                                 <td>{{data.description}}</td>
                                 <td>{{data.remarks}}</td>
                                 <td class="tdCenter">
                                    <span class='label label-success' v-if="data.status==1">Admin Settled</span>
                                    <span class='label label-danger' v-else-if="data.status==2">Admin Declined</span>
                                    <span class='label label-danger' v-else-if="data.status==3">Cancelled</span>
                                    <span class='label label-warning' v-else>Pending</span>
                                 </td>
                                 <td class="tdCenter">
                                    <router-link :to="{ name: 'EditWithdrawals', params: {id: data.id } }" title="Edit Withdrawal" v-if="data.status!=1 && data.status!=2">
                                       <i class="ion ion-ios-compose table-edit"></i>
                                    </router-link>
                                 </td>
                              </tr>
                           </tbody>
                           <tbody v-else>
                              <tr>
                                 <td colspan="12" class="tdCenter" style="padding: 30px 0;">
                                    <b>No Records Found</b>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                     
                     <div class="pagination" v-if="last_page > 1">
                        <a v-if="prev_page_url" href="#" @click="dopagination(prevPage)" class="next">
                           « Previous
                        </a>
                        <span v-else class="disabled">« Previous</span>
                        <span v-if="last_page > max_display_pagination">
                           <span v-for="index in last_page">
                              <span v-if="index==1||index==2">
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">
                                       {{index}}
                                    </a>
                                 </span>
                                 <span v-if="(index==2) && firstDotted">..</span>
                              </span>
                              <span v-if="randomPageNumber.includes(index)">
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">
                                       {{index}}
                                    </a>
                                 </span>
                              </span>
                              <span v-if="index==last_page||index==last_page-1">
                                 <span v-if="(index==last_page-1) && lastDotted">
                                    ..
                                 </span>
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">
                                       {{index}}
                                    </a>
                                 </span>
                              </span>
                           </span>
                        </span>
                        <span v-else>
                           <span v-for="index in last_page">
                              <span class="current" v-if="index==current_page">
                                 {{index}}
                              </span>
                              <span v-else>
                                 <a href="#" @click="dopagination(index)">{{index}}</a>
                              </span>
                           </span>
                        </span>
                        <a v-if="next_page_url" href="#" @click="dopagination(nextPage)" class="next">
                           Next »
                        </a>
                        <span v-else class="disabled">Next »</span>
                     </div>
                  </div>
                  <div class="box-footer"></div>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   export default {
      name: "WithdrawList",
      data() {
         return {
            withdrawArr : {},
            account_list : {},
            status : 0,
            account_id : '',
            dispplayFrom : 0,   
            dispplayTo : 0,  
            totalData : 0, 
            display_limit : 50,
            alert_message : '',
            userData : '',

            // Pagination Variables
            prev_page_url : false,
            next_page_url : false,
            last_page : 1,
            current_page : null,
            max_display_pagination : 9,
            randomPageNumber : {}, 
            firstDotted: false,
            lastDotted: false,
            prevPage : '',
            nextPage : '',
         }
      },
      created(){
         this.com_user_type_access([1,2], true);
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         this.userData = userData;
         if(userData.user_level == 1) {
            this.$router.push('dashboard');
         }

         //this.loadAllResellers();
         this.dopagination(0);
      },
      methods: {
         dopagination(page_no = ''){
            loader.show();
            var rootObject = this;
            let querystr = 'account_id='+this.account_id+'&status='+this.status+'&paginate='+this.display_limit; 
            if(page_no > 0){
               querystr +="&page="+page_no;
            }
            //console.log(querystr);
            axios.get('affiliate/withdraws?'+querystr).then(function (response) {
               rootObject.populateData(response);
               if(Object.keys(rootObject.account_list).length===0){
                  rootObject.account_list = response.data.account_list;
               }
               //console.log(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },

         populateData(response){
            this.withdrawArr = response.data.withdraw_list.data;
            this.totalData = response.data.withdraw_list.total;
            this.dispplayFrom = response.data.withdraw_list.from;
            this.dispplayTo = response.data.withdraw_list.to;
            this.display_limit = response.data.withdraw_list.per_page;
            this.paginationGenerate(response);
            loader.hide();
         },

         paginationGenerate(response){
            this.prev_page_url = response.data.withdraw_list.prev_page_url;
            this.next_page_url = response.data.withdraw_list.next_page_url;
            this.last_page = response.data.withdraw_list.last_page;
            this.current_page = response.data.withdraw_list.current_page;
            this.randomPageNumber = [];
            this.firstDotted = false;
            this.lastDotted = false;
            this.prevPage = this.current_page-1;
            this.nextPage = this.current_page+1;
            let countableOtherPages = this.max_display_pagination-4;
            if(this.current_page==1 || this.current_page ==2){
               for(let i = 3; i <= (3+(countableOtherPages-1)); i++){
                  this.randomPageNumber.push(i);
               }
               this.lastDotted=true;
            }
            else if(this.current_page==this.last_page || this.current_page ==this.last_page-1){
               let endPage = this.last_page-2;
               for(let i = endPage; i >= endPage - (countableOtherPages-1); i--){
                  this.randomPageNumber.push(i);
               }
               this.firstDotted = true;
            }
            else{
               let interval = parseInt(countableOtherPages / 2);
               if(this.current_page <= (interval+3)){
                  for(let i = 3; i <= (3+(countableOtherPages-1)); i++){
                     this.randomPageNumber.push(i);
                  }
                  this.lastDotted=true;
               }
               else if (this.current_page >= (this.last_page - (interval+2))) 
               {
                  let endPage = this.last_page-2;
                  for(let i = endPage; i >= endPage - (countableOtherPages-1); i--){
                     this.randomPageNumber.push(i);
                  }
                  this.firstDotted = true;
               }else{
                  for(let i = this.current_page; i <= (this.current_page+interval); i++){
                     this.randomPageNumber.push(i);
                  }

                  for(let i = (this.current_page-1); i >= (this.current_page-interval); i--){
                     this.randomPageNumber.push(i);
                  }
               }
            }
            //console.log(this.randomPageNumber);
         },

         RefreshNow(){
            this.dopagination(0);
         },

      },

      mounted: function() {
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>